/**
 * Cross-Tab Event System für Olympus
 * Ermöglicht Kommunikation zwischen geöffneten Tabs
 */

// Event-Typen
export const TAB_EVENTS = {
  ENTITY_CREATED: 'olympus-entity-created',
  ENTITY_UPDATED: 'olympus-entity-updated',
  DATA_REFRESH: 'olympus-data-refresh',
};

// Entity-Typen
export const ENTITY_TYPES = {
  PERSON: 'person',
  INSTITUTION: 'institution',
  MASSNAHME: 'massnahme',
  AUFGABE: 'aufgabe',
  KONTO: 'konto',
  BUCHUNG: 'buchung',
  DOKUMENT: 'dokument',
};

/**
 * Event senden wenn eine neue Entity erstellt wurde
 */
export function emitEntityCreated(entityType, data) {
  window.dispatchEvent(new CustomEvent(TAB_EVENTS.ENTITY_CREATED, {
    detail: { type: entityType, data, timestamp: Date.now() }
  }));
}

/**
 * Event senden wenn eine Entity aktualisiert wurde
 */
export function emitEntityUpdated(entityType, data) {
  window.dispatchEvent(new CustomEvent(TAB_EVENTS.ENTITY_UPDATED, {
    detail: { type: entityType, data, timestamp: Date.now() }
  }));
}

/**
 * Allgemeines Daten-Refresh Event
 */
export function emitDataRefresh(scope) {
  window.dispatchEvent(new CustomEvent(TAB_EVENTS.DATA_REFRESH, {
    detail: { scope, timestamp: Date.now() }
  }));
}
